/* eslint-disable */
import { loadGads, gadsLoaded, clearGadsCookies } from "./gads";

const KEY = "rbtun_consent";
const VERSION = 2;
const PH_KEY = "phc_DbsPb39SRc8z3EiQ6Dhj6ikv4H4rTKcht9d4sZSesceP";

export const readConsent = () => {
  try {
    const c = JSON.parse(localStorage.getItem(KEY) || "null");
    return c && c.v === VERSION ? c : null;
  } catch {
    return null;
  }
};

export const hasMarketingConsent = () => !!readConsent()?.marketing;

export const saveConsent = ({ statistics, marketing }) => {
  const phActive = !!(window.posthog && window.posthog.__loaded);
  const gadsActive = gadsLoaded();
  const c = { v: VERSION, statistics: !!statistics, marketing: !!marketing, ts: new Date().toISOString() };
  localStorage.setItem(KEY, JSON.stringify(c));
  if (gadsActive && !c.marketing) {
    window.gtag("consent", "update", { ad_storage: "denied", ad_user_data: "denied", ad_personalization: "denied", analytics_storage: "denied" });
  }
  applyConsent(c);
  if ((!c.statistics && phActive) || (!c.marketing && gadsActive)) window.location.reload();
  return c;
};

const loadPosthog = () => {
  if (window.posthog && window.posthog.__loaded) {
    window.posthog.opt_in_capturing();
    return;
  }
  if (window.posthog && window.posthog.__SV) return;
  !(function (t, e) {
    var o, n, p, r;
    e.__SV || ((window.posthog = e), (e._i = []), (e.init = function (i, s, a) {
      function g(t, e) { var o = e.split("."); 2 == o.length && ((t = t[o[0]]), (e = o[1])), (t[e] = function () { t.push([e].concat(Array.prototype.slice.call(arguments, 0))); }); }
      ((p = t.createElement("script")).type = "text/javascript"), (p.crossOrigin = "anonymous"), (p.async = !0),
        (p.src = s.api_host.replace(".i.posthog.com", "-assets.i.posthog.com") + "/static/array.js"),
        (r = t.getElementsByTagName("script")[0]).parentNode.insertBefore(p, r);
      var u = e;
      for (void 0 !== a ? (u = e[a] = []) : (a = "posthog"), u.people = u.people || [],
        u.toString = function (t) { var e = "posthog"; return "posthog" !== a && (e += "." + a), t || (e += " (stub)"), e; },
        u.people.toString = function () { return u.toString(1) + ".people (stub)"; },
        o = "init capture register register_once register_for_session unregister unregister_for_session getFeatureFlag getFeatureFlagPayload isFeatureEnabled reloadFeatureFlags onFeatureFlags onSessionId identify setPersonProperties group resetGroups reset get_distinct_id getGroups get_session_id get_session_replay_url alias set_config startSessionRecording stopSessionRecording sessionRecordingStarted captureException opt_in_capturing opt_out_capturing has_opted_in_capturing has_opted_out_capturing clear_opt_in_out_capturing debug".split(" "),
        n = 0; n < o.length; n++) g(u, o[n]);
      e._i.push([i, s, a]);
    }), (e.__SV = 1));
  })(document, window.posthog || []);
  window.posthog.init(PH_KEY, {
    api_host: "https://ap.emergent.sh",
    person_profiles: "identified_only",
    session_recording: { recordCrossOriginIframes: true, capturePerformance: false },
  });
};

const clearPosthog = () => {
  if (window.posthog && typeof window.posthog.opt_out_capturing === "function") window.posthog.opt_out_capturing();
  const parts = window.location.hostname.split(".");
  const domains = parts.map((_, i) => parts.slice(i).join(".")).filter((d) => d.includes("."));
  document.cookie.split(";").map((c) => c.split("=")[0].trim()).filter((n) => n.startsWith("ph_") || n.startsWith("__ph")).forEach((n) => {
    document.cookie = `${n}=; Max-Age=0; path=/`;
    domains.forEach((d) => { document.cookie = `${n}=; Max-Age=0; path=/; domain=.${d}`; });
  });
  [localStorage, sessionStorage].forEach((s) => Object.keys(s).filter((k) => k.startsWith("ph_") || k.startsWith("__ph")).forEach((k) => s.removeItem(k)));
};

export const applyConsent = (c) => {
  if (c && c.statistics) loadPosthog();
  else clearPosthog();
  if (c && c.marketing) loadGads(c.statistics);
  else clearGadsCookies();
};
